export default function (state) {
    let data = '?';

    if (state.Name && state.Name.length >= 2) {
        data += 'Name=' + state.Name + '&';
    }
    if (state.FirstName && state.FirstName.length >= 2) {
        data += 'FirstName=' + state.FirstName + '&';
    }
    if (state.MiddleName && state.MiddleName.length >= 2) {
        data += 'MiddleName=' + state.MiddleName + '&';
    }
    if (state.Birthday) {
        data += 'Birthday.Serialized=' + state.Birthday + '&';
    }
    if (state.PassportSeries && state.PassportSeries.length >= 2) {
        data += state.IsInternationalPassport ? 'ForeignPassportSeries=' : 'RussianPassportSeries=';
        data += state.PassportSeries + '&';
    }
    if (state.PassportNumber && state.PassportNumber.length >= 2) {
        data += state.IsInternationalPassport ? 'ForeignPassportNumber=' : 'RussianPassportNumber=';
        data += state.PassportSeries + '&';
    }
    if (state.FullConditions && data !== '?') {
        data += 'FullConditions=' + state.FullConditions + '&';
    }
    if (state.AgreementCode && state.AgreementCode.length >= 2) {
        data = '?AgreementCode=' + state.AgreementCode + '&';
    }
    if (data === '?') return '';
    return data + '_=' + new Date().getTime();
}